import { FAIRE_ACADEMY_PAGE_STATE } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useGetFaireAcademyPageState";
import { NonBreaking } from "@faire/web/common/string";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

export const getOpenWithFaireFooterCardTitleText = (
  pageState: keyof typeof FAIRE_ACADEMY_PAGE_STATE
) => {
  switch (pageState) {
    case FAIRE_ACADEMY_PAGE_STATE.LOGGED_IN_ESTABLISHED:
      return (
        <StrictLocalMsg
          id="q7B2rk"
          defaultMessage="Know someone opening a store?"
          description={{
            text: "Header title for the footer card of the Open with Faire landing page, for logged in & established customers",
            img: "https://cdn.faire.com/fastly/ff47ec9a94bf1bbfb760806a3b916b74ad732d9fda69d349cb11f81af7156d39.png",
          }}
        />
      );
    case FAIRE_ACADEMY_PAGE_STATE.LOGGED_IN_NEW_APPLIED:
      return null;
    case FAIRE_ACADEMY_PAGE_STATE.LOGGED_IN_NEW_NOT_APPLIED:
    case FAIRE_ACADEMY_PAGE_STATE.LOGGED_OUT:
    default:
      return (
        <StrictLocalMsg
          id="xJVZ3N"
          defaultMessage="Ready to Open{nbsp}with{nbsp}Faire?"
          description={{
            text: "Header title for the footer card of the Open with Faire landing page, for logged out customers",
            img: "https://cdn.faire.com/fastly/ab57e63fb57f7bb6b1c4ba17ef7d6e4b17498a2d948ad170744bdec79e03b438.png",
          }}
          values={{
            nbsp: NonBreaking.space,
          }}
        />
      );
  }
};
